import { render, staticRenderFns } from "./overallPredictiveRiskScoreComponent.vue?vue&type=template&id=64006003"
import script from "./overallPredictiveRiskScoreComponent.vue?vue&type=script&lang=js"
export * from "./overallPredictiveRiskScoreComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports